var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useContext, useEffect, useState } from 'react';
import { CurrencyContext } from '../../context/currency';
import { UserContext } from '../../context/user';
import { appEnv } from '../../env';
import { LoadingContext } from '../../context/loading';
import { WalletConnectionType } from '../../types/blockchain';
import { sleep } from '../../utils/async';
import { createChunks } from '../../utils/chunks';
import { useImxActions } from '../imx/use-imx-actions';
export function useTransferAssetsMpc() {
    var setServerLoading = useContext(LoadingContext).setServerLoading;
    var _a = useContext(UserContext), user = _a.user, reconnectUser = _a.reconnectUser, balances = _a.balances, _b = _a.magicLinkContext, isMagicLoggedInWithUser = _b.isMagicLoggedInWithUser, reconnectMagicLink = _b.reconnectMagicLink, loginWithMagicLink = _b.loginWithMagicLink;
    var imxClient = useContext(CurrencyContext).imxClient;
    var _c = useState(false), initialized = _c[0], setInitialized = _c[1];
    var _d = useState([]), tokenIdsChunks = _d[0], setTokenIdsChunks = _d[1];
    var _e = useState(0), tokenIdsTransferedCount = _e[0], setTokenIdsTransferedCount = _e[1];
    var _f = useState(false), tokensFetched = _f[0], setTokensFetched = _f[1];
    var _g = useState(false), tokensFetchStarted = _g[0], setTokensFetchStarted = _g[1];
    var _h = useState(false), assetsTransferInProgress = _h[0], setAssetsTransferInProgress = _h[1];
    var _j = useState(false), tokensTransferInProgress = _j[0], setTokensTransferInProgress = _j[1];
    var _k = useState(false), transferDone = _k[0], setTransferDone = _k[1];
    var imx = useImxActions();
    useEffect(function () {
        function refetchUser() {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, reconnectUser()];
                        case 1:
                            _a.sent();
                            setInitialized(true);
                            return [2 /*return*/];
                    }
                });
            });
        }
        refetchUser();
    }, []);
    useEffect(function () {
        if (user && imxClient && !tokensFetchStarted)
            fetchTokensToTransfer();
    }, [tokensFetchStarted, user, imxClient]);
    function fetchTokensToTransfer() {
        return __awaiter(this, void 0, void 0, function () {
            var cursor, remaining, localTokenIdsChunks, response, chunks;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setTokensFetchStarted(true);
                        if (!user)
                            return [2 /*return*/];
                        if (!user.magicLinkWalletAddress)
                            return [2 /*return*/];
                        if (!imxClient)
                            return [2 /*return*/];
                        setServerLoading(true);
                        setTokensFetched(false);
                        remaining = 0;
                        localTokenIdsChunks = [];
                        _a.label = 1;
                    case 1: return [4 /*yield*/, imxClient.listAssets({
                            collection: appEnv.blockchain.collectionAddress,
                            user: user.magicLinkWalletAddress,
                            pageSize: 200,
                            cursor: cursor,
                            status: 'imx',
                        })];
                    case 2:
                        response = _a.sent();
                        cursor = response.cursor;
                        remaining = response.remaining;
                        if (response.result.length > 0) {
                            localTokenIdsChunks.push(response.result.map(function (token) { return token.token_id; }));
                        }
                        _a.label = 3;
                    case 3:
                        if (remaining === 1) return [3 /*break*/, 1];
                        _a.label = 4;
                    case 4:
                        chunks = createChunks(localTokenIdsChunks.flat(), 30);
                        setTokenIdsChunks(chunks);
                        setTokensFetched(true);
                        setServerLoading(false);
                        return [2 /*return*/];
                }
            });
        });
    }
    function transferTokensToMpc() {
        return __awaiter(this, void 0, void 0, function () {
            var ctaBalance, ctaBalanceValue, usdcBalance, usdcBalanceValue, progress, _i, tokenIdsChunks_1, tokenIdsChunk;
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!user || !user.magicLinkWalletAddress || !user.email || !user.mpcWalletAddress)
                            return [2 /*return*/];
                        if (!imxClient)
                            return [2 /*return*/];
                        ctaBalance = (_a = balances === null || balances === void 0 ? void 0 : balances.game) === null || _a === void 0 ? void 0 : _a.find(function (balance) { return balance.symbol === 'CTA'; });
                        ctaBalanceValue = ctaBalance === null || ctaBalance === void 0 ? void 0 : ctaBalance.balance;
                        usdcBalance = (_b = balances === null || balances === void 0 ? void 0 : balances.game) === null || _b === void 0 ? void 0 : _b.find(function (balance) { return balance.symbol === 'USDC'; });
                        usdcBalanceValue = usdcBalance === null || usdcBalance === void 0 ? void 0 : usdcBalance.balance;
                        setAssetsTransferInProgress(tokenIdsChunks.length > 0);
                        setTokensTransferInProgress(Boolean(tokenIdsChunks.length === 0 &&
                            ((ctaBalance && ctaBalanceValue && ctaBalanceValue !== '0') ||
                                (usdcBalance && usdcBalanceValue && usdcBalanceValue !== '0'))));
                        return [4 /*yield*/, reconnectMagicLink(user.magicLinkWalletAddress)];
                    case 1:
                        _c.sent();
                        if (!!isMagicLoggedInWithUser) return [3 /*break*/, 3];
                        return [4 /*yield*/, loginWithMagicLink(user.email)];
                    case 2:
                        _c.sent();
                        _c.label = 3;
                    case 3:
                        progress = 0;
                        _i = 0, tokenIdsChunks_1 = tokenIdsChunks;
                        _c.label = 4;
                    case 4:
                        if (!(_i < tokenIdsChunks_1.length)) return [3 /*break*/, 7];
                        tokenIdsChunk = tokenIdsChunks_1[_i];
                        return [4 /*yield*/, imx.transferERC721({
                                walletFrom: {
                                    address: user.magicLinkWalletAddress,
                                    connectionType: WalletConnectionType.MAGIC_LINK,
                                    email: user.email,
                                },
                                toAddress: user.mpcWalletAddress,
                                tokenIds: tokenIdsChunk,
                            })];
                    case 5:
                        _c.sent();
                        progress += tokenIdsChunk.length;
                        setTokenIdsTransferedCount(progress);
                        _c.label = 6;
                    case 6:
                        _i++;
                        return [3 /*break*/, 4];
                    case 7:
                        if (!(ctaBalance && ctaBalanceValue && ctaBalanceValue !== '0')) return [3 /*break*/, 9];
                        return [4 /*yield*/, imx.transferERC20({
                                walletFrom: {
                                    address: user.magicLinkWalletAddress,
                                    connectionType: WalletConnectionType.MAGIC_LINK,
                                    email: user.email,
                                },
                                quantity: ctaBalanceValue,
                                toAddress: user.mpcWalletAddress,
                                tokenAddress: ctaBalance.token_address,
                            })];
                    case 8:
                        _c.sent();
                        _c.label = 9;
                    case 9:
                        if (!(usdcBalance && usdcBalanceValue && usdcBalanceValue !== '0')) return [3 /*break*/, 11];
                        return [4 /*yield*/, imx.transferERC20({
                                walletFrom: {
                                    address: user.magicLinkWalletAddress,
                                    connectionType: WalletConnectionType.MAGIC_LINK,
                                    email: user.email,
                                },
                                quantity: usdcBalanceValue,
                                toAddress: user.mpcWalletAddress,
                                tokenAddress: usdcBalance.token_address,
                            })];
                    case 10:
                        _c.sent();
                        _c.label = 11;
                    case 11: return [4 /*yield*/, sleep(2500)];
                    case 12:
                        _c.sent();
                        setAssetsTransferInProgress(false);
                        setTokensTransferInProgress(false);
                        setTransferDone(true);
                        setServerLoading(false);
                        return [2 /*return*/];
                }
            });
        });
    }
    return {
        initialized: initialized,
        transferTokensToMpc: transferTokensToMpc,
        tokensFetched: tokensFetched,
        tokenIdsTransferedCount: tokenIdsTransferedCount,
        tokenIdsChunks: tokenIdsChunks,
        assetsTransferInProgress: assetsTransferInProgress,
        tokensTransferInProgress: tokensTransferInProgress,
        transferDone: transferDone,
    };
}
